import type { ProfileFile } from './types'

export const PROFILE_FILE_FORMAT = 'qms.operation-profile'

/** A profile file read from disk; the server checks the document itself. */
export function readProfileFile(
  text: string,
): { file: ProfileFile; name: string } | { error: 'notJson' | 'notProfile' | 'version' } {
  let raw: unknown
  try {
    raw = JSON.parse(text)
  } catch {
    return { error: 'notJson' }
  }
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return { error: 'notProfile' }
  const obj = raw as Record<string, unknown>
  if (obj.format !== PROFILE_FILE_FORMAT) return { error: 'notProfile' }
  if (obj.version !== 1) return { error: 'version' }
  if (!obj.document || typeof obj.document !== 'object') return { error: 'notProfile' }
  const name = typeof obj.name === 'string' ? obj.name.trim() : ''
  return { file: raw as ProfileFile, name }
}
